import { ListCarRentals } from '~/features/russia/Organization/CarRentals/ListCarRentals'
import { Container } from '~/shared/ui/Layout'

export function ListCarRentalPageRussia() {
  return (
    <Container>
      <ListCarRentals />
    </Container>
  )
}
